import axiosFlow from '@/services/axios/axiosFlow'
import FilaStatusEnum from '@/models/entities/fila/FilaStatusEnum'

export default class FilaService {
  static async get(itensPorPagina, tiposDeCanaisSelecionados, statusId, gestorId, nomeOuDescricao, permitirAgendamento) {
    const params = new URLSearchParams()

    params.append('ItensPorPagina', itensPorPagina)

    if (tiposDeCanaisSelecionados) {
      tiposDeCanaisSelecionados.forEach(number => {
        params.append('CanalTiposIds', number)
      })
    }
    if (statusId) {
      params.append('StatusId', statusId)
    }
    if (gestorId) {
      params.append('GestorId', gestorId)
    }
    if (nomeOuDescricao) {
      params.append('NomeOuDescricao', nomeOuDescricao)
    }
    if (permitirAgendamento) {
      params.append('permitirAgendamento', permitirAgendamento)
    }

    return axiosFlow.get(`filas?${params}`).then(res => res.data.data.items)
  }

  static async getById(filaId) {
    return axiosFlow.get(`filas/${filaId}`).then(res => res.data.data)
  }

  static async getEstatisticas() {
    return axiosFlow.get('filas/estatisticas').then(res => res.data.data)
  }

  static async getQtdTotalFilas() {
    return axiosFlow.get('filas/estatisticas').then(res => res.data.data.total)
  }

  static async getFilasAtivas(itensPorPagina, gestorId) {
    let url = `filas?ItensPorPagina=${itensPorPagina}&StatusId=${FilaStatusEnum.Ativa}`
    url += gestorId ? `&GestorId=${gestorId}` : ''
    return axiosFlow.get(url).then(res => res.data.data.items)
  }

  static async getFilasSemPaginacaoEContadoresSla() {
    return axiosFlow.get('filas/sem-paginacao-e-contadores-sla').then(res => res.data.data)
  }

  static async getFilasDisponiveisParaAgendamento() {
    return axiosFlow.get('filas/disponiveis-agendamento').then(res => res.data.data)
  }

  static async getAtendimentos() {
    return axiosFlow.get('filas/atendimentos').then(res => res.data.data)
  }

  static async getCanais(filaId) {
    return axiosFlow.get(`filas/${filaId}/canais`).then(res => res.data.data)
  }

  static async getTiposDeCanaisNaoAssociados(filaId) {
    return axiosFlow.get(`filas/${filaId}/canais-tipos/nao-associados`).then(res => res.data.data)
  }

  static async getCanaisNaoAssociados(filaId, canalTipoId) {
    const params = new URLSearchParams()

    if (canalTipoId) {
      params.append('CanalTipo', canalTipoId)
    }

    return axiosFlow.get(`filas/${filaId}/canais/nao-associados?${params}`).then(res => res.data.data)
  }

  static async getAutoatendimentosAssociadosAFila(filaId) {
    return axiosFlow.get(`filas/${filaId}/canais/autoatendimentos`).then(res => res.data.data)
  }

  static async getTiposDeSolicitacoesAssociadosAUmaFila(filaId) {
    return axiosFlow.get(`filas/${filaId}/tipos-solicitacoes/associados?ItensPorPagina=100`)
      .then(res => res.data.data.items)
  }

  static async getTiposDeSolicitacoesNaoAssociadosAUmaFila(filaId) {
    return axiosFlow.get(`filas/${filaId}/tipos-solicitacoes/nao-associados`).then(res => res.data.data)
  }

  static async getTiposDeSolicitacoesDisponiveisParaAberturaManual(filaId) {
    return axiosFlow.get(`filas/${filaId}/tipos-solicitacoes/abertura-manual`).then(res => res.data.data)
  }

  static async getFilaFormularios(filaId) {
    return axiosFlow.get(`filas/${filaId}/formularios`).then(res => res.data.data)
  }

  static async getFormulariosNaoAssociados(filaId) {
    return axiosFlow.get(`filas/${filaId}/formularios/nao-associados`).then(res => res.data.data)
  }

  static async getFilaStatusTicket(filaId) {
    return axiosFlow.get(`filas/${filaId}/status-ticket`).then(res => res.data.data)
  }

  static async getFilaSlas(filaId, atendenteId) {
    const params = new URLSearchParams()

    if (filaId) {
      params.append('FilaId', filaId)
    }
    if (atendenteId) {
      params.append('AtendenteId', atendenteId)
    }

    return axiosFlow.get(`filas/slas?${params}`).then(res => res.data.data)
  }

  static async getFilaEquipes(filaId) {
    return axiosFlow.get(`filas/${filaId}/equipes`).then(res => res.data.data)
  }

  static async getEquipesNaoAssociadas(filaId) {
    return axiosFlow.get(`filas/${filaId}/equipes/nao-associadas`).then(res => res.data.data)
  }

  static async getAgentesFila(filaId) {
    return axiosFlow.get(`filas/${filaId}/agentes`).then(res => res.data.data)
  }

  static async getAgentesDoGestor(filaId) {
    return axiosFlow.get(`filas/agentes-gestor?FilaId=${filaId}`).then(res => res.data.data)
  }

  static async getFilasCanalTipoBot() {
    return axiosFlow.get('filas/possui-canal-tipo-bot').then(res => res.data.data)
  }

  static async getFilasQuePossuemSlasConfigurados() {
    return axiosFlow.get('filas/possui-sla-configurado').then(res => res.data.data)
  }

  static async create(body) {
    return axiosFlow.post('filas', body)
  }

  static async update(filaId, body) {
    return axiosFlow.put(`filas/${filaId}`, body)
  }

  static async ativarOuInativar(filaId, body) {
    return axiosFlow.put(`filas/${filaId}/ativada`, body)
  }

  static async associarFilaECanal(filaId, body) {
    return axiosFlow.post(`filas/${filaId}/canais`, body)
  }

  static async ativarOuInativarAssociacaoEntreFilaECanal(filaId, canalId, body) {
    return axiosFlow.put(`filas/${filaId}/canais/${canalId}/ativado`, body)
  }

  static async associarFilaETipoSolicitacao(filaId, associacaoData) {
    return axiosFlow.post(`filas/${filaId}/tipos-solicitacoes`, associacaoData)
  }

  static async atualizarAssociacaoEntreFilaETipoDeSolicitacao(filaId, associacaoData) {
    return axiosFlow.put(`filas/${filaId}/tipos-solicitacoes`, associacaoData)
  }

  static async getSlaPrimeiraResposta(filaId) {
    return axiosFlow.get(`filas/${filaId}/sla-primeira-resposta`).then(res => res.data.data)
  }

  static async atualizarSlaPrimeiraResposta(filaId, body) {
    return axiosFlow.put(`filas/${filaId}/sla-primeira-resposta`, body)
  }

  static async ativarOuInativarAssociacaoEntreFilaETipoDeSolicitacao(filaId, tipoSolicitacaoId, body) {
    return axiosFlow.put(`filas/${filaId}/tipos-solicitacoes/${tipoSolicitacaoId}/ativado`, body)
  }

  static async createFilaEquipe(filaId, body) {
    return axiosFlow.post(`filas/${filaId}/equipes`, body)
  }

  static async ativarOuInativarFilaEquipe(filaId, equipeId, body) {
    return axiosFlow.put(`filas/${filaId}/equipes/${equipeId}/ativada`, body)
  }

  static async associarFilaEFormulario(filaId, associacaoData) {
    return axiosFlow.post(`filas/${filaId}/formularios`, associacaoData)
  }

  static async atualizarAssociacaoEntreFilaEFormulario(filaId, associacaoData) {
    return axiosFlow.put(`filas/${filaId}/formularios`, associacaoData)
  }

  static async ativarOuInativarAssociacaoEntreFilaEFormulario(filaId, formularioId, body) {
    return axiosFlow.put(`filas/${filaId}/formularios/${formularioId}/ativada`, body)
  }

  static async createFilaStatusTicket(filaId, body) {
    return axiosFlow.post(`filas/${filaId}/status-ticket`, body)
  }

  static async updateFilaStatusTicket(filaId, statusTicketId, body) {
    return axiosFlow.put(`filas/${filaId}/status-ticket/${statusTicketId}`, body)
  }

  static async ativarOuInativarFilaStatusTicket(filaId, statusTicketId, body) {
    return axiosFlow.put(`filas/${filaId}/status-ticket/${statusTicketId}/ativado`, body)
  }
}
